import type { ReactNode } from 'react';
import Container from '../Container';

interface PageHeaderProps {
  title: string;
  description?: string | null;
  tag?: ReactNode;
  backButton?: ReactNode;
  bookmarkButton?: ReactNode;
  variant?: 'default' | 'media';
  mediaImageSrc?: string | null;
  mediaImageAlt?: string | null;
  sideTitle?: string | null;
  sideDescription?: string | null;
  mediaNode?: ReactNode;
  sideFooter?: ReactNode;
}

function PageHeader({
  title,
  description,
  tag,
  backButton,
  bookmarkButton,
  variant = 'default',
  mediaImageSrc,
  mediaImageAlt,
  sideTitle,
  sideDescription,
  mediaNode,
  sideFooter,
}: PageHeaderProps) {
  const isMediaVariant = variant === 'media';
  const hasMedia = !!mediaNode || !!mediaImageSrc;

  return (
    <div className="w-full bg-white pb-[16px] pt-[32px] md:bg-light-green md:pb-[32px]">
      <Container>
        <div className="col-span-12">
          {backButton && <div className="mb-[13px] mb-[16px] flex flex-col gap-[8px] md:mb-[16px]">{backButton}</div>}

          <div className="flex items-start justify-between gap-2">
            <h1 className="font-haffer text-sh-lg font-bold text-black-200">{title}</h1>
            {bookmarkButton && <div className="mt-sh-15 flex shrink-0">{bookmarkButton}</div>}
          </div>

          {isMediaVariant && hasMedia ? (
            <div className="mt-sh-30 grid gap-sh-30 md:grid-cols-2 md:items-start">
              <div className="min-w-0">
                {mediaNode ? (
                  mediaNode
                ) : (
                  <div className="highlight-image-border">
                    <img
                      src={mediaImageSrc ?? undefined}
                      alt={mediaImageAlt ?? undefined}
                      className="h-auto w-full object-cover"
                    />
                  </div>
                )}
              </div>
              <div className="min-w-0">
                {sideTitle && (
                  <h2 className="mb-[16px] font-haffer text-sh-30-38 font-bold text-black-200">{sideTitle}</h2>
                )}
                {sideDescription && (
                  <p className="font-haffersq text-sh-18-28 font-normal text-dark-grey">{sideDescription}</p>
                )}
                {sideFooter && <div className="mt-sh-24">{sideFooter}</div>}
              </div>
            </div>
          ) : (
            <>
              {description && <p className="mt-2 font-haffersq text-sh-xs font-normal text-dark-grey">{description}</p>}
              {tag && <div>{tag}</div>}
            </>
          )}
        </div>
      </Container>
    </div>
  );
}

export default PageHeader;
